/**
 * Scroll-in stagger for review cards (PDP 4-up, review wall) and the
 * landing quote stage. Cards stay visible until this file adds `.tb-reveal`.
 * Do not put opacity:0 on those selectors in CSS — a JS miss would hide
 * the whole grid.
 *
 * Desktop ≥990px scrolls `.page-wrapper`, not the document. An
 * IntersectionObserver with root:null never sees that movement, which is
 * how the banner copy used to stick at opacity 0. Same root as
 * assets/scroll-container.js. In-view cards that the observer misses
 * (late layout, squeeze breakpoint) get a short failsafe. Off-screen
 * cards wait for the observer so they do not pop in below the fold.
 */
(function (global) {
  const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
  const SQUEEZE = window.matchMedia('(min-width: 990px)');
  const FAILSAFE_MS = 1400;

  function intersectionRoot() {
    if (SQUEEZE.matches) {
      return document.querySelector('.page-wrapper');
    }
    return null;
  }

  /**
   * @param {Element} container
   * @param {string} selector
   */
  function revealCards(container, selector) {
    if (!container || !selector) return;
    const cards = Array.prototype.slice.call(container.querySelectorAll(selector));
    if (!cards.length) return;

    const pending = cards.filter((card) => {
      if (card.hidden) return false;
      if (card.hasAttribute('data-tb-revealed')) return false;
      return true;
    });
    if (!pending.length) return;

    if (REDUCE.matches) {
      pending.forEach((card) => {
        card.setAttribute('data-tb-revealed', '');
        card.classList.add('tb-reveal', 'is-in');
      });
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      {
        root: intersectionRoot(),
        threshold: 0.12,
        rootMargin: '0px 0px -6% 0px',
      }
    );

    pending.forEach((card, i) => {
      card.setAttribute('data-tb-revealed', '');
      card.style.setProperty('--tb-reveal-delay', Math.min(i, 7) * 70 + 'ms');
      card.classList.add('tb-reveal');
      io.observe(card);
      window.setTimeout(() => {
        if (card.classList.contains('is-in')) return;
        const root = intersectionRoot();
        const rr = root
          ? root.getBoundingClientRect()
          : { top: 0, bottom: window.innerHeight };
        const r = card.getBoundingClientRect();
        if (r.bottom > rr.top + 8 && r.top < rr.bottom - 8) {
          card.classList.add('is-in');
          io.unobserve(card);
        }
      }, FAILSAFE_MS);
    });
  }

  global.tbRevealCards = revealCards;
})(window);
